import { Children, cloneElement } from 'react';

import { useInterviewsPutQueryById } from '../../../Common/Queries/interviewsQueries';

/**
 * this function is utility function for formate the data in required formate
 * @param {*} values previous values
 * @param {*} editedValue changed values
 * @returns values in required formate
 */
export const formateData = (values, editedValue) => {
  const basicInfo = {
    round: values.round,
    status: values.status,
    text: editedValue.reason,
  };
  const otherDetails = {
    versionKey: values.versionKey,
    message: values.message || '',
    customLink: values.customLink || '',
    timeZone: values.timeZone || 'Asia/Kolkata',
  };
  const interviewDetails = {
    startTime: values.startTime,
    duration: values.duration,
    interviewer: editedValue.interviewer,
    location: values.location || 'ONLINE',
  };
  return {
    application: values.application,
    basicInfo,
    interviewDetails,
    otherDetails,
  };
};

export function UpdateInterviewerContainer({ children, interview, id }) {
  const putToInterview = useInterviewsPutQueryById();

  const handleUpdate = (finalValues) => {
    const reqBody = formateData(interview, finalValues);
    const reqParams = { reqBody, reqId: id };
    putToInterview.mutate(reqParams);
  };

  return Children.only(
    cloneElement(children, { putToInterview, interview, handleUpdateInterviewer: handleUpdate })
  );
}
